import axios from 'axios';
import { getAPIHost } from '@rsos/utils/metaTags';
import {
  CREATE_ADELE_TEST_START,
  CREATE_ADELE_TEST_SUCCESS,
  CREATE_ADELE_TEST_ERROR,
  START_ADELE_TEST_START,
  START_ADELE_TEST_SUCCESS,
  START_ADELE_TEST_ERROR,
  LEI_TEST_START,
  LEI_TEST_SUCCESS,
  LEI_TEST_ERROR,
  LIS_TEST_START,
  LIS_TEST_SUCCESS,
  LIS_TEST_ERROR,
  RAD_TEST_START,
  RAD_TEST_SUCCESS,
  RAD_TEST_ERROR,
  HERMES_TEST_START,
  HERMES_TEST_SUCCESS,
  HERMES_TEST_ERROR,
  PSAP_DASHBOARD_TEST_START,
  PSAP_DASHBOARD_SUCCESS,
  PSAP_DASHBOARD_ERROR,
  UPDATE_TEST_RESULTS,
  RESET_RESULTS,
  ADELE_LOGGER_START,
  ADELE_LOGGER_ERROR,
  ADELE_LOGGER_SUCCESS,
} from './actionTypes';

let host = getAPIHost();

const apiInstance = (apiParams, token) => {
  return axios.create({
    baseURL: `${host}${apiParams}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};

const psapInstance = (apiParams, token) => {
  return axios.create({
    baseURL: `${host}${apiParams}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-RapidSOS-role': 'Admin',
    },
  });
};

const lisInstance = auth => {
  return axios.create({
    baseURL: `${host}/v1`,
    headers: {
      'Content-Type': 'application/held+xml',
      accept: 'application/held+xml',
    },
    auth: {
      username: auth.client_id,
      password: auth.client_secret,
    },
  });
};

export const createIntegrationTestAction =
  (requestBody, productToken) => dispatch => {
    dispatch({ type: CREATE_ADELE_TEST_START });

    return apiInstance('/v1/adele', productToken)
      .post(`/tests`, requestBody)
      .then(response => {
        return dispatch({ type: CREATE_ADELE_TEST_SUCCESS, payload: response });
      })
      .catch(error => {
        return dispatch({ type: CREATE_ADELE_TEST_ERROR, payload: error });
      });
  };

export const startIntegrationTestAction =
  (testId, productToken) => dispatch => {
    dispatch({ type: START_ADELE_TEST_START });

    return apiInstance('/v1/adele', productToken)
      .post(`/tests/${testId}`, {})
      .then(response => {
        return dispatch({ type: START_ADELE_TEST_SUCCESS, payload: response });
      })
      .catch(error => {
        return dispatch({ type: START_ADELE_TEST_ERROR, payload: error });
      });
  };

export const updateTestResults = testResults => dispatch => {
  dispatch({ type: UPDATE_TEST_RESULTS, payload: testResults });
};

export const startLEITestAction =
  (callerID, token, name, rave_id) => dispatch => {
    dispatch({ type: LEI_TEST_START });
    let endpoint;
    if (rave_id && name === 'Rave Smart911') {
      endpoint = `/location?caller_id=${callerID}&agency_identifier=${rave_id}`;
    } else {
      endpoint = `/location?caller_id=${callerID}`;
    }
    return apiInstance('/v1/rsos', token)
      .get(endpoint)
      .then(response => {
        return dispatch({ type: LEI_TEST_SUCCESS, payload: response });
      })
      .catch(error => {
        return dispatch({ type: LEI_TEST_ERROR, payload: error });
      });
  };

export const startLISTestAction = (callerID, auth) => dispatch => {
  let xml = `
      <?xml version="1.0" encoding="UTF-8"?>
        <locationRequest xmlns="urn:ietf:params:xml:ns:geopriv:held">
         <locationType>any</locationType>
          <device xmlns="urn:ietf:params:xml:ns:geopriv:held:id">
            <uri>tel:+${callerID}</uri>
          </device>
      </locationRequest>
  `;
  dispatch({ type: LIS_TEST_START });

  return lisInstance(auth)
    .post(`/location`, xml)
    .then(response => {
      return dispatch({ type: LIS_TEST_SUCCESS, payload: response });
    })
    .catch(error => {
      return dispatch({ type: LIS_TEST_ERROR, payload: error });
    });
};

export const startRADTestAction =
  (callerID, token, name, rave_id) => dispatch => {
    dispatch({ type: RAD_TEST_START });
    let endpoint;
    if (rave_id && name === 'Rave Smart911') {
      endpoint = `/v2/emergency-data?caller_id=${callerID}&agency_identifier=${rave_id}`;
    } else {
      endpoint = `/v2/emergency-data?caller_id=${callerID}`;
    }

    return apiInstance(endpoint, token)
      .get()
      .then(response => {
        return dispatch({ type: RAD_TEST_SUCCESS, payload: response });
      })
      .catch(error => {
        return dispatch({ type: RAD_TEST_ERROR, payload: error });
      });
  };

export const startHERMESTestAction = (callerID, token) => dispatch => {
  dispatch({ type: HERMES_TEST_START });
  let connectToHermes = (callerID, token) => {
    return new Promise(function (resolve, reject) {
      let ret = host.replace('https://', '');

      let connection = new WebSocket(
        `wss://${ret}/v1/hermes/subscribe?topics=tel://${callerID}&access_token=${token}`,
      );
      connection.onopen = function () {
        resolve(connection);
      };
      connection.onerror = function (err) {
        reject(err);
      };
    });
  };

  return connectToHermes(callerID, token)
    .then(res => {
      res.close();
      return dispatch({ type: HERMES_TEST_SUCCESS, payload: true });
    })
    .catch(error => {
      return dispatch({ type: HERMES_TEST_ERROR, payload: error });
    });
};

export const startPsapDashTest = (callerID, token) => dispatch => {
  dispatch({ type: PSAP_DASHBOARD_TEST_START });
  return psapInstance(`/v1/psap-dashboard?caller_id=${callerID}`, token)
    .get()
    .then(response => {
      return dispatch({ type: PSAP_DASHBOARD_SUCCESS, payload: response });
    })
    .catch(error => {
      return dispatch({ type: PSAP_DASHBOARD_ERROR, payload: error });
    });
};

export const adeleLogger = (test_id, token, testResults) => dispatch => {
  dispatch({ type: ADELE_LOGGER_START });

  const requestBody = {
    name: `Test results`,
    event_type: 'Integrations Tests',
    data: { results: testResults },
    timestamp: Date.now(),
  };

  return apiInstance(`/v1/adele`, token)
    .post(`/tests/${test_id}/logs`, requestBody)
    .then(response => {
      return dispatch({ type: ADELE_LOGGER_SUCCESS, payload: response });
    })
    .catch(error => {
      return dispatch({ type: ADELE_LOGGER_ERROR, payload: error });
    });
};

export const updateResults = testResults => dispatch => {
  return dispatch({ type: UPDATE_TEST_RESULTS, payload: testResults });
};

export const resetResults = () => dispatch => {
  return dispatch({ type: RESET_RESULTS });
};
